import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { hideToast, showToast } from 'redux/Toast/toastSlice'

export const useToast = () => {
  const dispatch = useDispatch()

  const displayToast = (
    message: string,
    type: 'success' | 'error',
    durationMs: number = 2000
  ) => {
    dispatch(showToast({ message, type }))

    // Auto-hide after configurable delay (default 2s)
    setTimeout(() => {
      dispatch(hideToast())
    }, durationMs)
  }

  return { displayToast }
}
